import { useDebounceFn } from '@vueuse/core'
import { watch } from 'vue'
import { useRoute } from 'vue-router'
import dateFormatter from './formatters/date'
import numberFormatter from './formatters/number'

export const fmt = {
  ...dateFormatter,
  ...numberFormatter,
}

/**
 * Watch the route full path, and trigger callback when query / params change
 * but don't trigger when route name change (move away to other page).
 *
 * @param callback
 */
export const whenRouteChange = (
  callback: () => void,
  watchSource?: () => unknown,
) => {
  const route = useRoute()
  const routeName = route.name // cache route name
  watch(
    watchSource ?? (() => route.fullPath),
    () => {
      if (route.name === routeName) {
        callback()
      }
    },
    { immediate: true },
  )
}

export const debounce = useDebounceFn
